<template>
    <div style="padding: 0 15px">
        <!-- 工具栏 -->
        <div class="filter-container">
            <el-button class="filter-item" size="small" icon="el-icon-circle-plus-outline" type="primary" @click="yonghuquanxianbtn">添加到用户组</el-button>
            <el-input class="filter-item" size="small" v-model="search" clearable placeholder="名称模糊查询" style="width: 220px"></el-input>
        </div>

        <!-- table 列表-->
        <el-table class="grayTableTile" size="mini"  v-loading="listLoading" :data="tableList" border style="width: 100%" @sort-change="handleAgeSortChange">
            <el-table-column prop="name" label="分组名称" sortable='custom'></el-table-column>
            <el-table-column prop="desc" label="显示名称" sortable='custom'></el-table-column>
            <el-table-column prop="addTime" label="创建时间" sortable='custom'></el-table-column>
            <el-table-column prop="" label="操作" width="150">
                <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button type="text" class="bdc-table-op-danger" :disabled="!scope.row.del" @click="quanxianshanchu(scope.row)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

         <!-- 分页 -->
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" style="margin-top:0;" />

    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {userdoRemoveGroups} from '@Sys~/api/sys'
import { arrSlice, sortKeys } from '@/filters'
export default {
    components: {Pagination},
    data() {
        return {
            search: '',
            listLoading: false,
            originalCaseTable:[],// 排序原始数据
            caseTable: [], // 存放后端一次性返回的所有数据
            handCaseTable: [], // 存放处理假分页后的数据(等距切割)
            tableData: [], // 切割后页面应展示的数据
            total: 0,
            listQuery: {
               pageNo: 1,
               pageSize: 10 
            },

            userInfo: {}, // 详情
        }
    },

    computed: {
        tableList() {
            let caseTable = this.caseTable
            const search = this.search.toLowerCase().replace(/\s+/g,"");
            if(search) {
                caseTable = this.caseTable.filter(data => {
                return String(data['name']).toLowerCase().indexOf(search) > -1 
                        || String(data['desc']).toLowerCase().indexOf(search) > -1
                })
            }

            this.total = caseTable.length
            // 将一维数组切割成二维数组
            this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
            this.tableData = this.handCaseTable[this.listQuery.pageNo-1]
            return this.tableData
        }
    },

    methods: {
        init(row, list) {
            this.userInfo = row
            this.search = ''
            this.listLoading = false
            this.tableData = []
            this.total = 0
            this.listQuery = {
               pageNo: 1,
               pageSize: 10 
            }
            this.caseTable = list
            this.originalCaseTable = JSON.parse(JSON.stringify(list))
        },


        // 排序
        handleAgeSortChange(e) {
            if(e.order) {
                const order = e.order == 'descending' ? false : true
                this.caseTable.sort(sortKeys(e.prop, order))
            } else {
                this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
            }
        },

        // 添加到用户组
        yonghuquanxianbtn() {
            this.$emit('handleAddGroups')
        },

        // 单个删除
        quanxianshanchu(row) {
            const data = {
                userId: [this.userInfo.id],
                groupId: [row.id]
            }
            this.$confirm('确认删除用户分组： "' + row.name + '" 吗？').then(_ => {
                userdoRemoveGroups(data).then(response => {
                    if (response.code == 1) {
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        this.$emit('getAgainList')
                    }
                });
            }).catch(_ => { });
        }
    }
}
</script>